// import { useEffect, useState } from "react";



import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

// Your Stripe publishable key
const stripePromise = loadStripe('pk_test_51NcUyLSC5UPsHJr4yzy9IgRZe9zmAOymjpI4D2yj616PaHMkULAToS1XC4wsb1UgVCbzuf1S4Bz8HxjCsyqLP1hB003qAdaSVM');


const AddCardForm = () => {
  const stripe = useStripe(); // Stripe instance
  const elements = useElements(); // Elements instance
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(''); // Error state
  const [success, setSuccess] = useState(''); // Success message state



  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    // Get card details from CardElement
    const cardElement = elements.getElement(CardElement);

    // Create a token with Stripe using the card element
    const { error, paymentMethod  } = await stripe.createPaymentMethod({
      type: 'card', // Specify that this is a card payment method
      card: cardElement,
    });

    if (error) {
      setError(error.message);
    } else {
      // Token is created, send it to the server for further processing
      console.log('Success! Token:', paymentMethod );

          const response = await fetch('https://api.stripe.com/v1/payment_methods/%s/attach', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ customerId:sessionStorage.getItem("stripe_cust_id"), token: paymentMethod  }),
    });

    const data = await response.json();
    if (data.success) {
      setSuccess('Card saved successfully!');
      // onCardAdded(); // Call the function to refresh saved cards
    } else {
      setError('Failed to save card: ' + data.error);
    }
      setSuccess('Card added successfully!');
      
      // Call a function to send the token to your backend
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
    
      <CardElement 
        options={{
          style: {
            base: {
              fontSize: '18px',
              color: '#424770',
              '::placeholder': { color: '#aab7c4' },
            },
            invalid: { color: '#9e2146' },
          },
        }}
      />
      <button type="submit" disabled={!stripe || loading}>
        {loading ? 'Processing...' : 'Add Card'}
      </button>

      {error && <div style={{ color: 'red' }}>{error}</div>}
      {success && <div style={{ color: 'green' }}>{success}</div>}
    </form>
  );
};


const PaymentComponent = () => {

  const [stripePromised, setStripePromise] = useState(null);
  //const [clientSecret, setClientSecret] = useState("");

  // const stripePromise = loadStripe(stripePromised);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/constantapi/getstripekey`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (r) => {
      const response = await r.json();
      // console.log( response.response.stripe_p_dev_key )
      setStripePromise(loadStripe(response.response.stripe_p_dev_key));
    });
  }, []);
  return (
    <Elements stripe={stripePromise}>
      <AddCardForm />
    </Elements>
  );
};

export default PaymentComponent;





// import { Elements } from "@stripe/react-stripe-js";
// import CheckoutForm from "./checkout";
// import { loadStripe } from "@stripe/stripe-js";

// function PaymentComponent(props) {
//   const [stripePromise, setStripePromise] = useState(null);
//   const [clientSecret, setClientSecret] = useState("");

//   useEffect(() => {
//     fetch(
//       `${process.env.REACT_APP_API_BASE_URL}/constantapi/getstripekey`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     ).then(async (r) => {
//       const response = await r.json();
//       // console.log( response.response.stripe_p_dev_key )
//       setStripePromise(loadStripe(response.response.stripe_p_key));
//     });
//   }, []);

//   // useEffect(() => {
//   //   fetch("https://apps.Grepix.ca/webservices/1.1.0/index.php/constantapi/createpaymentintent", {
//   //     method: "POST",
//   //     headers: {
//   //       'Content-Type': 'application/json'
//   //     },
//   //     body: JSON.stringify({ amount: Math.round(props.payAmount * 100) }),
//   //   }).then(async (result) => {
//   //     var { clientSecret } = await result.json();
//   //     setClientSecret(clientSecret);
//   //   });
//   // }, []);

//   // console.log("am", props.payAmount);

//   useEffect(() => {
//     fetch(
//       `${process.env.REACT_APP_API_BASE_URL}/constantapi/createpaymentintent`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           amount: props.payAmount,
//           currency: props.city_cur,
//           description: "HireMe booking website",
//         }),
//       }
//     ).then(async (result) => {
//       var response = await result.json();

//       // console.log(response);
//       setClientSecret(response.response);
//     });
//   }, []);

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           overflow: "auto",
//         }}
//       >
//         {/*         <img src="images/logo.png" height={"100px"} />
//          */}{" "}
//         <h1 style={{ color: "blueviolet", fontWeight: "700" }}>Stripe</h1>
//       </div>
//       {clientSecret && stripePromise && (
//         <Elements stripe={stripePromise} options={{ clientSecret }}>
//           <CheckoutForm
//             setride={props.setride}
//             clientSecret={clientSecret}
//             setThank={props.setThank}
//             date={props.date}
//             offers={props.offers}
//             payAmount={props.payAmount}
//             setDriverCancel={props.setDriverCancel}
//             closePayHandle={props.closePayHandle}
//             startTimer={props.startTimer}
//           />
//         </Elements>
//       )}
//     </div>
//   );
// }

// export default PaymentComponent;
